import managerCRUDActions from '../actions/manager';
import CRUDReducer from './CRUDReducer';

const managerCRUDReducer = new CRUDReducer(managerCRUDActions);

export default (state, action) => managerCRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/manager.js